const ReactDOM = require('react-dom')

export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback)
  }
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
  prevRouterProps,
}) => {
  // If navigating to a job page (not using back button)
  if (location.pathname.startsWith('/jobs/')) {
    const savedPosition = getSavedScrollPosition(location)
    // If there's no saved position (first visit to this page), scroll to top
    if (!savedPosition) {
      return [0, 0]
    }
  }

  // Default behavior for other routes (including back button)
  return true
}
